import { render, staticRenderFns } from "./BowSection.vue?vue&type=template&id=39f389a5&"
import script from "./BowSection.vue?vue&type=script&lang=js&"
export * from "./BowSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports